import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Capacitor } from '@capacitor/core';
import { faCircleCheck } from '@fortawesome/pro-duotone-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';

import { DiversityType, passwordStrength } from 'check-password-strength';

import { MapProgressStrength } from '../../../utils/progress-strength';

export type PasswordState<T = string> = { [key in DiversityType]?: T | undefined } & { passwordStrength?: number };

@Component({
  selector: 'mom-form-field-password',
  templateUrl: './form-field-password.component.html',
  styleUrls: ['./form-field-password.component.scss']
})
export class FormFieldPasswordComponent implements OnInit {
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() required: boolean;

  @Output() keyupEnter = new EventEmitter<void>();

  faCircleCheck = faCircleCheck;
  faEye = faEye;
  faEyeSlash = faEyeSlash;

  initialState: PasswordState = {};
  passwordState: PasswordState = { ...this.initialState };
  passwordStates: { diversityType: DiversityType; requirement: string }[] = [
    { diversityType: 'lowercase', requirement: 'Lowercase' },
    { diversityType: 'uppercase', requirement: 'Uppercase' },
    { diversityType: 'symbol', requirement: 'Special character' },
    { diversityType: 'number', requirement: 'Number' }
  ];
  showPasswordIcon: boolean;
  showPasswordTextInd: boolean;
  showRequirements = true;
  type = 'password';

  ngOnInit(): void {
    this.formCtrl.valueChanges.subscribe((value) => this.checkPasswordStrength(value));
    this.showPasswordIcon = Capacitor.getPlatform() !== 'web';
  }

  onClickPasswordIcon(): void {
    this.showPasswordTextInd = !this.showPasswordTextInd;
    this.type = this.showPasswordTextInd ? 'text' : 'password';
  }

  private checkPasswordStrength(password: string = ''): void {
    this.passwordState = { ...this.initialState };
    this.passwordState.passwordStrength = MapProgressStrength(passwordStrength(password).id);
    passwordStrength(password).contains.forEach((el, _) => {
      this.passwordState[el] = el;
    });
  }
}
